import styled from 'styled-components'
import { TEXT_STYLES } from 'TEXT_STYLES'

export const Subtitle = styled.div`
  ${TEXT_STYLES.BodyBlack};
  color: ${props => props.theme.colors.grey500};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`
